export const JSON_ONE = {
   
    "meId": "201910300123",
    "pgId": "60",
    "orderNum": "0567845",
    "custVPA": "dsdsdsfds@okhdfcbank"
    }



